import { render, staticRenderFns } from "./DynamicHome.vue?vue&type=template&id=1459d320"
import script from "./DynamicHome.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports